import { foundations } from "@chakra-ui/theme/foundations"
export default foundations.fonts
